// @flow

import React from "react";
import ReactDOM from "react-dom";
import 'semantic-ui-css/semantic.min.css';
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";

const root = document.getElementById("root");
if (root) {
  ReactDOM.render(<App />, root);
  registerServiceWorker();
} else {
  console.error("Cannot mount app");
}



// WEBPACK FOOTER //
// ./src/index.js